import { ElementType, FC, PropsWithChildren } from 'react'

import { TextLargeStrong } from '../../Typography/Typography'

import styles from './PageSection.module.scss'

export interface PageSectionProps {
  icon: ElementType
  title: string
  id?: string
}

export const PageSection: FC<PropsWithChildren<PageSectionProps>> = (props) => {
  const { children, icon: Icon, title, id } = props

  return (
    <div className={styles.pageSection} id={id}>
      <div className={styles.titleWrapper}>
        <Icon />
        <TextLargeStrong>{title}</TextLargeStrong>
      </div>
      {children}
    </div>
  )
}
